import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button, Drawer, Layout, Menu } from "antd";
import { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import { ThemeContext } from "../contexts/ThemeContext";
import { brand, neutral, surface } from "../theme/tokens";
import { getMenuOfUser } from "../redux/menu/getMenuOfUser";
import HeaderConek from "./Header/HeaderConek";
// import SnowEffect from "./Header/SnowEffect";
const { Header, Sider, Content } = Layout;
export default function Body() {
  const { isDarkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();

  //#region State
  const listMenu = useSelector(
    (state) => state.persistedReducer.getListMenuUserSlice?.menuOfUser.data
  );
  const [collapsed, setCollapsed] = useState(true); // bật tắt sidebar
  // const [listMenu, setListMenu] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  //#endregion State

  const location = useLocation();

  // Key của các nhóm menu cấp 1 (nhóm có menu con).
  //
  // Bản cũ lấy từ hằng `rootSubmenuKeys` trong Slider/adminmenu.jsx — một danh
  // sách SLUG viết cứng ("home", "customer", "settings"...). Nhưng menu thật
  // dựng từ API và key là String(item.id), tức là "8", "12"... nên phép kiểm tra
  // `rootSubmenuKeys.indexOf(latestOpenKey) === -1` LUÔN đúng, nhánh accordion
  // không bao giờ chạy và mọi nhóm cứ mở chồng lên nhau.
  const rootSubmenuKeys = useMemo(
    () =>
      (listMenu || [])
        .filter((item) => item.children?.length > 0)
        .map((item) => String(item.id)),
    [listMenu]
  );

  // Đường dẫn hiện tại -> mục đang chọn và nhóm chứa nó.
  // Khớp theo đoạn đường dẫn dài nhất để "/collections/information/5" vẫn nhận
  // ra mục "/collections".
  const { selectedKey, parentKey } = useMemo(() => {
    let best = { selectedKey: null, parentKey: null, length: -1 };

    const visit = (items, parent) => {
      for (const item of items || []) {
        const url = item.url;
        if (
          url &&
          url !== "/" &&
          location.pathname.startsWith(url) &&
          url.length > best.length
        ) {
          best = { selectedKey: String(item.id), parentKey: parent, length: url.length };
        }
        if (item.children?.length > 0) visit(item.children, String(item.id));
      }
    };

    visit(listMenu, null);

    if (best.length === -1 && location.pathname === "/") {
      const home = (listMenu || []).find((item) => item.url === "/");
      if (home) best = { selectedKey: String(home.id), parentKey: null, length: 1 };
    }
    return best;
  }, [listMenu, location.pathname]);

  // Mở sẵn nhóm chứa trang đang xem (ví dụ sau khi F5 hoặc mở bằng link trực tiếp)
  useEffect(() => {
    if (parentKey) setOpenKeys([parentKey]);
  }, [parentKey]);

  // Custom menu styles for dark mode
  const menuStyle = {
    borderInlineEnd: "none",
    backgroundColor: isDarkMode ? brand.navBg : surface.card,
    color: isDarkMode ? surface.onDarkMuted : neutral[900],
  };
  // Add custom CSS to handle hover states in dark mode

  const headerStyle = {
    color: surface.card,
    height: 64,
    lineHeight: "64px",
    // backgroundColor: surface.card,
    backgroundColor: isDarkMode ? brand.navBg : surface.card,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: isDarkMode
      ? "0px 2px 4px 0px rgba(255, 255, 255, 0.05)"
      : "0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
    width: "100%",
    zIndex: 1000,
  };
  //#region function
  // const onClick = (e) => {
  //   // navigate(e.key);
  // };

  // Mở nhóm mới thì đóng nhóm đang mở — mỗi lúc chỉ một nhóm bung ra.
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      // Nhóm lồng sâu hơn cấp 1 thì giữ nguyên cả chuỗi đang mở
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  //#endregion function
  // Thêm hook kiểm tra kích thước màn hình
  const useWindowSize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerWidth, window.innerHeight]);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return size;
  };

  // Trong component Body
  const [width] = useWindowSize();
  const isMobile = width < 768; // Điểm breakpoint cho mobile

  //#region useEffect
  // Tự động thu gọn sidebar khi màn hình nhỏ
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);

  // Style của menu phải bơm bằng tay: antd tô nền menu con bằng biến nội bộ,
  // ConfigProvider không chạm tới được.
  //
  // Bản cũ chỉ bơm khi bật chế độ tối, mà trong đó lại viết các luật cho
  // `.ant-menu-light` — những luật đó không bao giờ khớp vì lúc ấy menu đang là
  // dark. Giờ bơm cho cả hai chế độ, mỗi bên đúng luật của mình.
  useEffect(() => {
    const styleElement = document.createElement("style");

    styleElement.textContent = isDarkMode
      ? `
          /* Menu con sáng hơn nền một nấc, đọc ra như khối lồng vào trong */
          .ant-menu-dark .ant-menu-sub.ant-menu-inline {
            background: var(--op-nav-sub) !important;
          }
          .ant-menu-dark .ant-menu-item:hover,
          .ant-menu-dark .ant-menu-submenu-title:hover {
            color: var(--op-on-dark) !important;
            background-color: rgba(255, 255, 255, 0.08) !important;
          }
          /* Nhóm cha đang chứa trang hiện tại */
          .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title {
            color: var(--op-on-dark) !important;
            background-color: rgba(255, 255, 255, 0.06) !important;
          }
          /* Mục đang chọn — kể cả khi nằm trong menu con hoặc popup lúc thu gọn.
             Đây là chỗ DUY NHẤT trên thanh điều hướng dùng màu thương hiệu:
             nền trầm nên màu này nổi hẳn lên, không cần tô thêm chỗ nào khác. */
          .ant-menu-dark .ant-menu-item-selected,
          .ant-menu-dark .ant-menu-sub .ant-menu-item-selected,
          .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
            background-color: var(--op-nav-active) !important;
          }
          .ant-menu-dark .ant-menu-item-selected,
          .ant-menu-dark .ant-menu-item-selected a {
            color: var(--op-on-dark) !important;
          }
        `
      : `
          .ant-menu-light .ant-menu-sub.ant-menu-inline {
            background: var(--op-brand-subtle) !important;
          }
          .ant-menu-light .ant-menu-item:hover,
          .ant-menu-light .ant-menu-submenu-title:hover {
            color: var(--op-brand) !important;
            background-color: var(--op-brand-subtle) !important;
          }
          .ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title {
            color: var(--op-brand) !important;
          }
          .ant-menu-light .ant-menu-item-selected,
          .ant-menu-light .ant-menu-sub .ant-menu-item-selected,
          .ant-menu-submenu-popup.ant-menu-light .ant-menu-item-selected {
            background-color: var(--op-brand) !important;
          }
          .ant-menu-light .ant-menu-item-selected,
          .ant-menu-light .ant-menu-item-selected a {
            color: var(--op-on-dark) !important;
          }
        `;

    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, [isDarkMode]);

  // SWR: menu đã được hydrate từ cache của phiên (nếu có) ngay trong initialState,
  // ở đây chỉ việc revalidate. Dedupe + force nằm trong `condition` của thunk nên
  // gọi thẳng là an toàn, không cần guard theo listMenu (guard cũ khiến menu vĩnh
  // viễn không được làm mới sau lần load đầu).
  useEffect(() => {
    dispatch(getMenuOfUser());
  }, [dispatch]);



  //#endregion useEffect

  return (
    <div className="body">
      <Layout style={{ height: "100vh", position: "relative" }}>
        
        {/* <SnowEffect count={15} /> */}

        <Header style={headerStyle}>
          <HeaderConek />
        </Header>
        <Layout style={{ backgroundColor: "white" }}>
          {isMobile ? (
            <>
              <Button
                type="primary"
                icon={<MenuUnfoldOutlined />}
                onClick={() => setDrawerVisible(true)}
                style={{ position: "fixed", left: 20, top: 70, zIndex: 99 }}
              />
              <Drawer
                placement="left"
                closable={true}
                onClose={() => setDrawerVisible(false)}
                visible={drawerVisible}
                width={250}
                style={{
                  backgroundColor: isDarkMode ? brand.navBg : surface.card,
                }}
              >
                {listMenu?.length > 0 && (
                  <Menu
                    // onClick={(e) => {
                    //   // onClick(e);
                    //   setDrawerVisible(false); // Đóng drawer sau khi chọn menu
                    // }}
                    style={{
                      borderInlineEnd: "none",
                      backgroundColor: isDarkMode ? brand.navBg : surface.card,
                      color: isDarkMode ? surface.onDarkMuted : neutral[900],
                    }}
                    mode="inline"
                    inlineIndent={10}
                    selectedKeys={selectedKey ? [selectedKey] : []}
                    openKeys={openKeys}
                    onOpenChange={onOpenChange}
                    items={renderMenuItems(listMenu)}
                  />
                )}
              </Drawer>
            </>
          ) : (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              width={250}
              style={{
                backgroundColor: isDarkMode ? brand.navBg : surface.card,
                overflowY: "auto",
              }}
            >
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: "16px",
                  width: "100%",
                  height: 64,
                  color: isDarkMode ? surface.card : neutral[900],
                }}
              />
              <div className="demo-logo-vertical" />
              <>
                <Menu
                  style={menuStyle}
                  mode="inline"
                  inlineIndent={10}
                  selectedKeys={selectedKey ? [selectedKey] : []}
                    openKeys={openKeys}
                  onOpenChange={onOpenChange}
                  items={renderMenuItems(listMenu)}
                  theme={isDarkMode ? "dark" : "light"}
                />
              </>
            </Sider>
          )}
          <Content>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export function renderMenuItems(items) {

  if (items?.length > 0)
    return items
      .map((item) => {
        if (item.children?.length > 0) {
          const subMenuItems = renderMenuItems(item.children);
          if (subMenuItems?.length > 0) {
            return {
              key: String(item.id),
              icon: <i className={item.icon} />,
              label: item.name,
              children: item.children.map((subMenu) => ({
                key: String(subMenu.id),
                label: <Link to={subMenu.url}>{subMenu.name}</Link>,
                path: subMenu.url,
              })),
              path: item.url,
            };
          }
        }
        return {
          key: String(item.id),
          icon: <i className={item.icon} />,
          label: <Link to={item.url}>{item.name}</Link>,
          path: item.url,
        };
      })
      .filter((item) => item !== null);
}
